'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _chart_utility = require('../../../../packages/common-utilities/src/chart_utility.js');

var _chart_utility2 = _interopRequireDefault(_chart_utility);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _chart_utility3 = require('../../../../packages/common-utilities/src/chart_utility');

var _d = require('../../../../src/main/resources/static/vendor/scripts/firevis-1.0.1/dependencies/d3-4.2.6/d3.min');

var d3 = _interopRequireWildcard(_d);

var _reactIntl = require('react-intl');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _date_formatter = require('../../../../packages/common-utilities/src/date_formatter.js');

var _date_formatter2 = _interopRequireDefault(_date_formatter);

var _ramda = require('ramda');

var _functional_utility = require('../../../../packages/common-utilities/src/functional_utility');

var _string_utility = require('../../../../packages/common-utilities/src/string_utility.js');

var _string_utility2 = _interopRequireDefault(_string_utility);

var _formatted_number = require('../global_components/formatted_number');

var _formatted_number2 = _interopRequireDefault(_formatted_number);

var _number_utility = require('../../../../packages/common-utilities/src/number_utility.js');

var _number_utility2 = _interopRequireDefault(_number_utility);

var _collection_utility = require('common-utilities/src/collection_utility');

var _functional_utility2 = require('common-utilities/src/functional_utility');

var _chart_utility4 = require('common-utilities/src/chart_utility');

var _tracking_utility = require('common-utilities/src/tracking_utility');

var _constants = require('../../../../packages/common-utilities/src/constants');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NAVChart = function (_React$Component) {
  _inherits(NAVChart, _React$Component);

  function NAVChart(props) {
    _classCallCheck(this, NAVChart);

    var _this = _possibleConstructorReturn(this, (NAVChart.__proto__ || Object.getPrototypeOf(NAVChart)).call(this, props));

    _this.trackChartHover = false;
    return _this;
  }

  _createClass(NAVChart, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return this.props.isFlatMode && ((0, _ramda.isNil)(nextProps) || !(0, _ramda.equals)(this.props, nextProps) || !(0, _ramda.equals)(this.state, nextState)) || !this.props.isFlatMode;
    }

    /* eslint-disable*/

  }, {
    key: 'createNAVChart',
    value: function createNAVChart(printWidth) {
      var _this2 = this;

      var _props = this.props,
          breakpoint = _props.breakpoint,
          intl = _props.intl,
          numberFormat = _props.numberFormat,
          tooltipImpl = _props.tooltipImpl;

      var data = this.props.navData;
      var decimalPlaces = (0, _ramda.isNil)(this.props.decimalPlaces) ? 4 : this.props.decimalPlaces;
      var postfix = (0, _ramda.isNil)(this.props.tooltipPostfix) ? '' : _string_utility2.default.getLocalizedString(this.props.intl, ' bps', this.props.tooltipPostfix);
      var yAxisLabelFraction = (0, _ramda.isNil)(this.props.yAxisFraction) ? decimalPlaces : this.props.yAxisFraction;
      var navPriceFieldKey = (0, _ramda.isNil)(this.props.navPriceFieldKey) ? "marketValueNavPrice" : this.props.navPriceFieldKey;
      var isDesktop = breakpoint > 3;
      var startDate = data[0].date;
      var endDate = data[data.length - 1].date;
      var currencyCode = this.props.currencyCode;
      var useDynamicxAxisIncrements = (0, _ramda.or)((0, _ramda.isNil)(this.props.useDynamicxAxisIncrements), this.props.useDynamicxAxisIncrements);
      var isUSHistoricalETF = _collection_utility.CollectionUtility.includes((0, _functional_utility2.pathOrEmptyArray)(["visibleData", "visibleCharts"], this.props), "ETF_HISTORICAL_NAV_MARKET_PRICE");
      var isUSHistoricalVIIV = _collection_utility.CollectionUtility.includes((0, _functional_utility2.pathOrEmptyArray)(["visibleData", "visibleCharts"], this.props), "ETF_HISTORICAL_NAV_VIIV");
      var lessThanOrEqualToFourMonths = (0, _chart_utility4.isInputRangeLessThanOrEqualToGivenMonths)(startDate, endDate, 4);
      var lessThanOrEqualToTwoMonths = (0, _chart_utility4.isInputRangeLessThanOrEqualToGivenMonths)(startDate, endDate, 2);

      if (useDynamicxAxisIncrements === false && _chart_utility2.default.isInputDateLessThanSixMonthOld(this.props.shareClassInceptionDate)) {
        var oneDayAfterInceptionDate = (0, _moment2.default)(this.props.shareClassInceptionDate).add(1, "days");
        startDate = oneDayAfterInceptionDate.format('YYYY-MM-DD');
      }
      var xAxisTicks = _chart_utility2.default.createXAxisTicksForDynamicRange(startDate, endDate, isDesktop);

      var yAxisTicks = this.props.yAxisTicks;
      var dateFormat = intl.formatMessage({ defaultMessage: "%m/%d/%Y", id: "pdp-chart-date-format" });
      var visibleDataPoints = (0, _functional_utility2.pathOrEmptyArray)(["visibleData", "visibleDataPoints"], this.props);
      var shouldShowCurrencyOnYAxis = _collection_utility.CollectionUtility.includes(visibleDataPoints, 'HISTORICAL_CHART_Y_AXIS_CURRENCY') || _collection_utility.CollectionUtility.includes(visibleDataPoints, 'HISTORICAL_CHART_DATA_Y_AXIS_SHOW_CURRENCY');
      var overrideShowCurrencyOnYAxis = _collection_utility.CollectionUtility.includes(visibleDataPoints, 'HISTORICAL_CHART_DATA_Y_AXIS_SHOW_CURRENCY');
      var shouldShowDenominatedCurrencyInHover = !_collection_utility.CollectionUtility.includes(visibleDataPoints, 'HISTORICAL_CHART_DENOMINATED_CURRENCY');
      var formattedValuePrefix = shouldShowDenominatedCurrencyInHover ? (0, _ramda.isNil)(currencyCode) ? "" : currencyCode : this.props.intl.formatMessage({
        defaultMessage: "NAV: ",
        id: "pdp-historical-price-hoover-NAV"
      });

      var formattedData = _collection_utility.CollectionUtility.reduce(data, function (map, value) {
        var formattedDate = _date_formatter2.default.getLocalFormattedDateForInjectIntl(value.date, _this2.props.intl);
        if (_collection_utility.CollectionUtility.includes((0, _functional_utility2.pathOrEmptyArray)(["visibleData", "formattingRules"], _this2.props), 'EMEA_ETF_HISTORICAL_NAV')) {
          if ((0, _moment2.default)(value.date).isBefore((0, _moment2.default)(_constants.EMEA_ETF_NAV_CUTOVER_DATE).toDate())) {
            decimalPlaces = 3;
          } else {
            decimalPlaces = 4;
          }
        }
        var formattedValue = formattedValuePrefix + _formatted_number2.default.prototype.numberFormatter(_number_utility2.default.convertToNumberWithCommas(_number_utility2.default.convertToAmount(value[navPriceFieldKey], decimalPlaces)), numberFormat) + postfix;
        map[value.date] = _extends({}, value, {
          formattedDate: formattedDate,
          formattedValue: formattedValue
        });

        if (isUSHistoricalETF) {
          map[value.date].formattedMarketValueNavPrice = formattedValuePrefix + _formatted_number2.default.prototype.numberFormatter(_number_utility2.default.convertToNumberWithCommas(_number_utility2.default.convertToAmount(value.marketValueNavPrice, decimalPlaces)), numberFormat) + postfix;
          if (isUSHistoricalVIIV) {
            map[value.date].formattedVerifiedIntraDayValue = formattedValuePrefix + _formatted_number2.default.prototype.numberFormatter(_number_utility2.default.convertToNumberWithCommas(_number_utility2.default.convertToAmount(value.verifiedIntraDayValue, decimalPlaces)), numberFormat) + postfix;
          }
        }
        return map;
      }, {});

      var marginLeft = 50;
      if (!(0, _ramda.isNil)(currencyCode)) {
        marginLeft = !shouldShowCurrencyOnYAxis ? (0, _functional_utility.isTabOrMobileBreakpoint)(breakpoint, 44, 95) : (0, _functional_utility.isTabOrMobileBreakpoint)(breakpoint, 85, 95);
      }

      var marginRight = !shouldShowCurrencyOnYAxis ? (0, _functional_utility.isTabOrMobileBreakpoint)(breakpoint, 44, 20) : (0, _functional_utility.isTabOrMobileBreakpoint)(breakpoint, 0, 20);
      var rangePaddingRight = (0, _functional_utility.isTabOrMobileBreakpoint)(breakpoint, "10", "50");
      var fontSize = (0, _functional_utility.isTabOrMobileBreakpoint)(breakpoint, "12px", "15px");
      var chartId = 'NAVChart' + navPriceFieldKey;
      var chartValues = [navPriceFieldKey];
      var colors = [_constants.CHART_COLORS.Pink];

      var shouldShowReturnRate = _collection_utility.CollectionUtility.includes(visibleDataPoints, 'HISTORICAL_CHART_RETURN_RATE');
      var xAxisShouldUseLongFormat = _collection_utility.CollectionUtility.includes(visibleDataPoints, 'HISTORICAL_CHART_X_AXIS_LONG_FORMAT');
      var xAxisShortDateFormat = _collection_utility.CollectionUtility.includes((0, _functional_utility2.pathOrEmptyArray)(["visibleData", "formattingRules"], this.props), 'HISTORICAL_NAV_CHART_XAXIS_DATE_IN_YYYYMM') ? "YYYY/MM" : "MMM YY";

      if (isUSHistoricalETF) {
        chartValues.push("marketValueNavPrice");
        colors.push(_constants.CHART_COLORS.Green);
        if (isUSHistoricalVIIV) {
          chartValues.push("verifiedIntraDayValue");
          colors.push(_constants.CHART_COLORS.Brown);
        }
      }

      var spec = (0, _ramda.mergeDeepLeft)({
        "keys": ["date"],
        "values": chartValues,
        "type": "line",
        "container": {
          "marginBottom": 50,
          "marginLeft": marginLeft,
          "marginRight": marginRight,
          "rangePaddingRight": rangePaddingRight,
          "height": 500
        },
        "style": {
          "fill": colors
        },
        "axis": {
          "x": {
            "show": true,
            "tick": {
              "padding": 5,
              "values": xAxisTicks
            },
            "label": {
              "show": true,
              "text": function text(d) {
                if (!isDesktop) {
                  return !lessThanOrEqualToTwoMonths ? xAxisShouldUseLongFormat ? _date_formatter2.default.getTranslatedDateYear(intl, (0, _moment2.default)(d).toDate(), 'short', 'numeric') : _date_formatter2.default.getDateInMonthYearFormatNoOffset(d, xAxisShortDateFormat) : d3.timeFormat(dateFormat)(d);
                }
                return !lessThanOrEqualToFourMonths ? xAxisShouldUseLongFormat ? _date_formatter2.default.getTranslatedDateYear(intl, (0, _moment2.default)(d).toDate(), 'short', 'numeric') : _date_formatter2.default.getDateInMonthYearFormatNoOffset(d, xAxisShortDateFormat) : d3.timeFormat(dateFormat)(d);
              },
              "style": {
                "font-family": "NBInternational",
                "font-size": fontSize
              }
            },
            "domain": [d3.timeParse("%Y-%m-%d")(startDate), d3.timeParse("%Y-%m-%d")(endDate)]
          },
          "y": {
            "domain": [yAxisTicks[0], yAxisTicks[yAxisTicks.length - 1]],
            "label": {
              "show": true,
              "text": function text(d) {
                if (d === 0.9970) {
                  return "";
                } else {
                  if (!(0, _ramda.isNil)(currencyCode) && overrideShowCurrencyOnYAxis) {
                    return currencyCode + _formatted_number2.default.prototype.numberFormatter(d3.format(",." + yAxisLabelFraction + "f")(d), numberFormat) + postfix;
                  }
                  return ((0, _ramda.isNil)(currencyCode) || !shouldShowCurrencyOnYAxis ? _formatted_number2.default.prototype.numberFormatter(d3.format(",." + yAxisLabelFraction + "f")(d), numberFormat) : currencyCode + _formatted_number2.default.prototype.numberFormatter(d3.format(",." + yAxisLabelFraction + "f")(d), numberFormat)) + postfix;
                }
              },
              "style": {
                "font-family": "NBInternational",
                "font-size": fontSize
              }
            },
            "tick": {
              "padding": 5,
              "values": yAxisTicks,
              "grid": true,
              "style": {
                "stroke": "lightgrey"
              }
            },
            "show": true
          }
        },
        "hoverLine": {
          "tooltip": {
            "style": {
              "font-size": fontSize
            },
            "text": function text(currentData) {
              _this2.trackingChartHover();
              if (!(0, _ramda.isNil)(tooltipImpl)) {
                return tooltipImpl(formattedData[currentData.date], intl, numberFormat);
              } else {
                var text = "<div style= 'text-align:left'>";
                var formattedItem = formattedData[currentData.date];

                text += "<div id='testchart' class='caption' style='font-weight:100'>" + formattedItem.formattedDate + "</div>";
                text += "<div class='caption' style='font-weight:400', 'border-radius:25px'>" + formattedItem.formattedValue + "</div>";
                if (shouldShowReturnRate) {
                  var returnRate = (formattedItem.navPrice - data[0].navPrice) / data[0].navPrice;
                  text += "<div class='caption' style='font-weight:100'>" + _string_utility2.default.getLocalizedString(intl, "", "pdp-historical-card-return-rate", { "percentage": _number_utility2.default.convertDecimalToPercentWith2FixedDecimals(returnRate) }) + "</div>";
                }
                text += "</div>";
                return text;
              }
            }
          }
        },
        "postProcessing": function postProcessing(chart) {
          chart.getPlot().selectAll(".tick line").style("stroke", "lightgrey");
        }
      }, _chart_utility3.COMMON_CHART_CONFIG);

      if (isUSHistoricalETF) {
        if (isUSHistoricalVIIV) {
          spec.hoverLine.tooltip.text = function (currentData) {
            _this2.trackingChartHover();
            var formattedItem = formattedData[currentData.date];
            return '<div style=\'text-align:left\'>\n            <div id=\'testchart\' className=\'caption\' style=\'font-weight:100\'>' + formattedItem.formattedDate + '</div>\n            <div className=\'caption\' style=\'font-weight:400\'>\n                <div style=\'width: 10px; height: 10px; background-color: ' + colors[0] + '; display: inline-block; border-radius: 25px;\'> </div>\n                <span className=\'caption\'\n                      style=\'font-weight:400; display: inline-block;\'>Net Asset Value ' + formattedItem.formattedValue + '</span>\n            </div>\n            <div className=\'caption\' style=\'font-weight:400\'>\n                <div style=\'width: 10px; height: 10px; background-color: ' + colors[1] + '; display: inline-block;border-radius: 25px;\'> </div>\n                <span className=\'caption\'\n                      style=\'font-weight:400; display: inline-block;\'>Market Price ' + formattedItem.formattedMarketValueNavPrice + '</span>\n            </div>\n            <div className=\'caption\' style=\'font-weight:400\'>\n                <div style=\'width: 10px; height: 10px; background-color: ' + colors[2] + '; display: inline-block; border-radius: 25px;\'> </div>\n                <span className=\'caption\'\n                      style=\'font-weight:400; display: inline-block;\'>VIIV ' + formattedItem.formattedVerifiedIntraDayValue + '</span>\n            </div>\n        </div>';
          };
        } else {
          spec.hoverLine.tooltip.text = function (currentData) {
            _this2.trackingChartHover();
            var formattedItem = formattedData[currentData.date];
            var netAssetValueHover = _this2.props.intl.formatMessage({
              defaultMessage: "Net Asset Value",
              id: "pdp-historical-chart-net-asset-legend"
            });
            var marketPriceHover = _this2.props.intl.formatMessage({
              defaultMessage: "Market Price",
              id: "pdp-historical-chart-market-price-legend"
            });
            return '<div style=\'text-align:left\'>\n            <div id=\'testchart\' className=\'caption\' style=\'font-weight:100\'>' + formattedItem.formattedDate + '</div>\n            <div className=\'caption\' style=\'font-weight:400\'>\n                <div style=\'width: 10px; height: 10px; background-color: ' + colors[0] + '; display: inline-block; border-radius: 25px;\'> </div>\n                <span className=\'caption\'\n                      style=\'font-weight:400; display: inline-block;\'>' + netAssetValueHover + ' ' + formattedItem.formattedValue + '</span>\n            </div>\n            <div className=\'caption\' style=\'font-weight:400\'>\n                <div style=\'width: 10px; height: 10px; background-color: ' + colors[1] + '; display: inline-block; border-radius: 25px;\'> </div>\n                <span className=\'caption\'\n                      style=\'font-weight:400; display: inline-block;\'>' + marketPriceHover + ' ' + formattedItem.formattedMarketValueNavPrice + '</span>\n            </div>\n        </div>';
          };
        }
      }

      var isValidPrintWidth = (0, _ramda.and)(printWidth, typeof printWidth === "number");
      if (isValidPrintWidth) {
        spec.container.width = (0, _chart_utility3.getChartPrintWidth)();
        spec.container.height = (0, _chart_utility3.getChartPrintHeight)();
      }
      return (0, _chart_utility.generateChart)((0, _chart_utility3.generateChartId)(chartId, isValidPrintWidth), "linechart", data, spec);
    }
  }, {
    key: 'trackingChartHover',
    value: function trackingChartHover() {
      var eventAction = this.props.eventAction;
      if (!this.trackChartHover) {
        _tracking_utility.TrackingUtility.trackEvent({
          "eventCategory": _tracking_utility.TrackingUtility.getEventCategory("pdp"),
          "eventAction": eventAction ? eventAction : "historical price",
          "eventLabel": _tracking_utility.TrackingUtility.getEventLabel("chartHover")
        });
        this.trackChartHover = true;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      if ((0, _ramda.isNil)(this.props.navData) || this.props.navData.length === 0) {
        return null;
      }
      var navChart = this.createNAVChart();
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: 'print-hide' },
          _react2.default.createElement(navChart)
        ),
        _react2.default.createElement(
          'div',
          { className: 'print-display', style: { display: "none" } },
          _react2.default.createElement(this.createNAVChart(800))
        )
      );
    }
  }]);

  return NAVChart;
}(_react2.default.Component);

/* eslint-enable*/


exports.default = (0, _reactIntl.injectIntl)(NAVChart, { withRef: true });